import React, { useRef, useState } from "react";
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';
import { useEffect } from 'react';
import { FaHeartbeat, FaTint, FaWeight, FaRulerVertical, FaHeart, FaRegHeart, FaHistory, FaPlus } from 'react-icons/fa';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { ChevronLeft, ChevronRight } from 'lucide-react'; // or any icon library you like
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
import { Bold } from 'react-feather';
import VitalsMetabolicsModal from './addVitals';
import ViewHistory from '../dialogs/dashboard/viewHistory';
import { useSelector } from 'react-redux';

const AddVitals = (props) => {
  const data = props.seriesData;
  const heartRateData = props.heartRateData;
  const bloodSugarData = props.bloodSugarData;
  const weightData = props.weightData;
  const waistData = props.waistData;
  const userData = useSelector((state) => state.apiService.login);
  const menuData = useSelector((state) => state.apiService.sharedReportsValidateCode);
  const isAccess = menuData.role === 'User';
  const isProvider =  userData.user_type_name === 'Provider'
  console.log(isProvider, "isProvider")
  console.log(props.isFromUserLandingPage, "props.isFromUserLandingPage")
  console.log(userData.user_type_name, "props.isAccess")
  const userId = isAccess ? menuData.user_id : (isProvider ? localStorage.getItem('patientUserId') : userData.user_id);
 
  // Simple function to get latest date
  const getLatestDateFromData = () => {
    if (data && data[0] && data[0].data && data[0].data.length > 0) {
      const lastPoint = data[0].data[data[0].data.length - 1];
      return moment(lastPoint[0]).format('M/D/YYYY');
    }
    return 'NA';
  };


  const chartOptions = {
    chart: {
      type: 'line',
      stacked: false,
      zoom: { enabled: false },
      toolbar: { show: false },
      offsetX: 0,
      offsetY: 0
    },
    dataLabels: { enabled: true },
    stroke: {
      curve: 'smooth',
      width: 3
    },
    markers: { size: 0 },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
        color: '#1b1ed5'
      }
    },
    yaxis: {
      labels: {
        style: { colors: '#8e8da4' },
        formatter: (val) => val?.toFixed(2),
      }
    },
    xaxis: {
      type: 'datetime',
      labels: {
        rotate: -15,
        formatter: (val) => {
          // Use the same date format as tooltip
          const formattedDate = moment(val).format('DD MMM YYYY'); 
          return formattedDate;
        },
      }
    },
    tooltip: { 
      shared: true, 
      intersect: false, 
      x: { 
        show: true,
        format: 'dd MMM yyyy'
      },
                                     custom: function({ series, seriesIndex, dataPointIndex, w }) {
         try {
           // Get the timestamp from the x-axis data
           const xAxisData = w.globals.seriesX[0];
           if (!xAxisData || !xAxisData[dataPointIndex]) {
             return '';
           }
           
           const timestamp = xAxisData[dataPointIndex];
           const date = moment(timestamp).format('DD MMM yyyy');
           
           // Get the value from the series
           const value = series[0] && series[0][dataPointIndex] ? series[0][dataPointIndex] : 'N/A';
           
           // For blood pressure chart, show both systolic and diastolic
           if (series.length > 1) {
             const systolicValue = series[0] && series[0][dataPointIndex] ? series[0][dataPointIndex] : 'N/A';
             const diastolicValue = series[1] && series[1][dataPointIndex] ? series[1][dataPointIndex] : 'N/A';
             
             return `
               <div style="padding: 8px; background: white; border: 1px solid #e0e0e0; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                 <div style="font-weight: bold; margin-bottom: 8px; color: #333; font-size: 14px;">${date}</div>
                 <div style="display: flex; align-items: center; margin-bottom: 4px;">
                   <span style="width: 12px; height: 12px; background: rgb(27, 154, 213); border-radius: 50%; margin-right: 8px;"></span>
                   <span style="color: #333; font-size: 13px;">Systolic: ${systolicValue}</span>
                 </div>
                 <div style="display: flex; align-items: center;">
                   <span style="width: 12px; height: 12px; background: rgb(34, 199, 127); border-radius: 50%; margin-right: 8px;"></span>
                   <span style="color: #333; font-size: 13px;">Diastolic: ${diastolicValue}</span>
                 </div>
               </div>
             `;
           } else {
             // For single series charts (heart rate, blood sugar, weight, waist)
             // Use the same date format as blood pressure chart
             return `
               <div style="padding: 8px; background: white; border: 1px solid #e0e0e0; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                 <div style="font-weight: bold; margin-bottom: 8px; color: #333; font-size: 14px;">${date}</div>
                 <div style="display: flex; align-items: center;">
                   <span style="width: 12px; height: 12px; background: rgb(27, 154, 213); border-radius: 50%; margin-right: 8px;"></span>
                   <span style="color: #333; font-size: 13px;">Value: ${value}</span>
                 </div>
               </div>
             `;
           }
         } catch (error) {
           console.error('Tooltip error:', error);
           return '';
         }
       }
    },
   // legend: { position: 'bottom', horizontalAlign: 'center', showForSingleSeries: true ,margin:10}
  };
  const bloodPressureChartOptions = {
    ...chartOptions,
    legend: {
      onItemClick: {
        toggleDataSeries: false,
      },
      onItemHover: {
        highlightDataSeries: false,
      },
    },
  };

  const vitalsDataIcons = [
    { icon: <FaHeartbeat />, value: props.BloodPressure, unit: 'mmHg', label: 'Blood Pressure' },
    { icon: <FaHeart />, value: props.heartRate, unit: 'bpm', label: 'Heart Rate' },
    { icon: <FaTint />, value: props.Bloodsugar, unit: 'mg/dL', label: 'Blood Sugar' },
    { icon: <FaWeight />, value: props.weight, unit: 'lbs', label: 'Weight' },
    { icon: <FaRulerVertical />, value: props.waist, unit: 'inches', label: 'Waist Size' },
  ];

  const [showVitalsModal, setShowVitalsModal] = useState(false);
  const [rowData, setRowData] = useState({ isAdd: true, isVitals: true });
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyType, setHistoryType] = useState("vitals");

  const chartAreaRef = useRef(null);
  const [chartHeight, setChartHeight] = useState(props.height || 0);

  // The card stretches to match the neighbouring widgets, so the chart is grown to
  // consume whatever vertical space is left instead of leaving a gap under the legend.
  useEffect(() => {
    const area = chartAreaRef.current;
    if (!area || typeof ResizeObserver === 'undefined') return;

    const SLIDE_TITLE_HEIGHT = 30;
    const measure = () => {
      const available = Math.round(area.clientHeight - SLIDE_TITLE_HEIGHT);
      setChartHeight((prev) => {
        const next = Math.max(props.height || 0, available);
        return Math.abs(next - prev) > 2 ? next : prev;
      });
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(area);
    return () => observer.disconnect();
  }, [props.height]);

  useEffect(() => {
    // Remove all margins globally
    const style = document.createElement('style');
    style.innerHTML = `
      .margin-0{
        margin: 0 !important;
      }
      
      /* Enhanced vitals icons styling */
      .icon-container:hover {
        background-color: var(--pmr-bg-subtle) !important;
        border-color: var(--pmr-primary) !important;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(2, 62, 138, 0.15);
      }
      
      .icon-container:hover span {
        color: var(--pmr-primary) !important;
        transform: scale(1.1);
      }
      
      .value-display {
        transition: all 0.3s ease;
      }
      
      .unit-display {
        transition: all 0.3s ease;
      }
      
      .label-display {
        transition: all 0.3s ease;
      }

      .apexcharts-legend-series,
      .apexcharts-legend-marker,
      .apexcharts-legend-text {
        cursor: default !important;
      }
      
      /* Responsive adjustments */
      @media (max-width: 768px) {
        .icon-container {
          width: 40px !important;
          height: 40px !important;
        }
        
        .icon-container span {
          font-size: 16px !important;
        }
        
        .value-display {
          font-size: 20px !important;
        }
        
        .unit-display {
          font-size: 10px !important;
        }
        
        .label-display {
          font-size: 11px !important;
          max-width: 80px !important;
        }
      }
      
      @media (max-width: 576px) {
        .icon-container {
          width: 35px !important;
          height: 35px !important;
        }
        
        .icon-container span {
          font-size: 14px !important;
        }
        
        .value-display {
          font-size: 18px !important;
        }
        
        .unit-display {
          font-size: 9px !important;
        }
        
        .label-display {
          font-size: 10px !important;
          max-width: 70px !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    console.log(data[0].data?.length, "heartRateData.data")
   
  }, [data]);

  // Handler for edit, delete, etc. 
  const handleEdit = (row) => {
    // Open your edit modal or logic
  };
  const handleEditMetabolics = (row) => {
    // Open your edit metabolics modal or logic
  };
  const handleDelete = (row) => {
    // Show confirm and delete logic
  };

  return (
    <div
      className="card shadow-lg p-0 d-flex flex-column margin-0"
      style={props.isFromUserLandingPage  ?{height:330, minHeight: "330px"}: { height: "350px", minHeight: "350px", maxHeight: "350px" } }
    >
      {/* <div className="card-header  title">{props?.header}</div> */}
                                                                                                                                                                                                                                                                                                                                                                                                                                                               <div className="card-header mb-0 d-flex justify-content-between align-items-center cardwidgehtHeaderBG">
              <h6 className="mb-0 text-capitalize">{props?.header}</h6>
              <span className="fontsize12 textcolorgray" >Last recorded on {getLatestDateFromData()}</span>
            </div>
             <div className="card-body p-0 flex-grow-1 widget-container d-flex flex-column" style={{ overflow: 'hidden', minHeight: 0 }}>
   
      <div className="px-3 flex-shrink-0">
        <div className="row flex-shrink-0 px-4" style={{ paddingBottom: 5 }}>
          <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-2 gap-md-2 w-100 p-0">
            {vitalsDataIcons.map((item, index) => (
              <div
                key={index}
                className="d-flex flex-column align-items-center justify-content-center flex-shrink-0 flex-grow-1 p-0"
                style={{ minWidth: 90, maxWidth: 140, flexBasis: '120px' }}
              >
                <div className="d-flex align-items-center mb-1 p-0">
                  <div className="d-flex align-items-center justify-content-center rounded-circle bg-light p-0" style={{ width: 32, height: 32 }}>
                    <span className="text-secondary" style={{ fontSize: 18 }}>{item.icon}</span>
                  </div>
                  <div className="d-flex flex-column align-items-start ms-2 p-0">
                    <div className="d-flex align-items-baseline p-0">
                      <span className="fw-bold lh-1" style={{ fontSize: 15, color: '#4b466a' }}>{item.value == 0 ? 'N/A':(item.value )}</span>
                      <span className="fw-semibold ms-2" style={{ fontSize: 14, color: '#ff9f43', alignSelf: 'baseline' }}>{item.unit}</span>
                    </div>
                    <span className="fw-medium text-secondary text-start mt-1" style={{ fontSize: 13 }}>{item.label}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        </div>
        <hr className="custom-hr mx-3 flex-shrink-0" />

        <div ref={chartAreaRef} style={{
    flex: '1 1 0',
    minHeight: 0,
    overflowY: 'auto',
    padding: '0 1rem',
  }} >
          <Carousel
            infiniteLoop={true}
            autoPlay={false}
            showIndicators={false}
            showStatus={false}
            showThumbs={false}
            renderArrowPrev={(onClickHandler, hasPrev, label) =>
              hasPrev && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  className="btn position-absolute top-50 start-0 translate-middle-y p-2"
                  style={{
                    zIndex: 10,
                    width: '45px',
                    height: '45px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  
                  }}
       
                >
                  <ChevronLeft size={20} color="#333" />
                </button>
              )
            }
            renderArrowNext={(onClickHandler, hasNext, label) =>
              hasNext && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  className="btn position-absolute top-50 end-0 translate-middle-y p-2"
                  style={{
                    zIndex: 10,
                    width: '45px',
                    height: '45px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  }}
                
                >
                  <ChevronRight size={20} color="#333" />
                </button>
              )
            }
          >
            <div style={{ marginRight: 40 }}>
              <label className='title text-start px-4'>{props.Bpheader}</label>
              <ReactApexChart
                className="px-4"
                options={data[0].data?.length > 0 ? bloodPressureChartOptions : {}}
                series={data}
                type={props.type}
                height={chartHeight}

              />
            </div>
            <div style={{ marginRight: 40 }}>
              <label className='title text-start px-4'>{props.heartRateheader}</label>
              <ReactApexChart
                className="px-4"
                options={heartRateData[0].data?.length > 0 ? chartOptions : {}}
                series={heartRateData}
                type={props.type}
                height={chartHeight}
              />
            </div>
            <div style={{ marginRight: 40 }}>
              <label className='title text-start px-4'>{props.bloodSugarDataheader}</label>
              <ReactApexChart
                className="px-4"
                options={bloodSugarData[0].data?.length > 0 ? chartOptions : {}}
                series={bloodSugarData}
                type={props.type}
                height={chartHeight}
              />
            </div>
            <div style={{ marginRight: 40 }}>
              <label className='title text-start px-4'>{props.wieghtDataheader}</label>
              <ReactApexChart
                className="px-4"
                options={weightData[0].data?.length > 0 ? chartOptions : {}}
                series={weightData}
                type={props.type}
                height={chartHeight}
              />
            </div>
            <div style={{ marginRight: 40 }}>
              <label className='title text-start px-4'>{props.waistheader}</label>
              <ReactApexChart
                className="px-4"
                options={waistData[0].data?.length > 0 ? chartOptions : {}}
                series={waistData}
                type={props.type}
                height={chartHeight}
              />
            </div>
          </Carousel>
        </div>
      </div>
             {props.isFromUserLandingPage && (
         <div className="card-footer d-flex align-items-center justify-content-between p-1 py-2" style={{ backgroundColor: 'white' }}>
            <div>
              <span
                className="modalfooterclickeventtext mx-2"
                style={{ cursor: 'pointer', marginRight: '10px' }}
                onClick={() => {
                  setRowData({ isAdd: true, isVitals: true });
                  setShowVitalsModal(true);
                }}
              >
                Add Vitals
              </span>
              <span style={{ margin: '0 8px', color: '#888' }}>|</span>
              <span
                className="modalfooterclickeventtext mx-2"
                style={{ cursor: 'pointer', marginLeft: '10px' }}
                onClick={() => {
                  setRowData({ isAdd: true, isVitals: false });
                  setShowVitalsModal(true);
                }}
              >
                Add Metabolics
              </span>

            </div>
            <div>
              <span
                className="modalfooterclickeventtext mx-2"
                style={{ cursor: 'pointer', marginLeft: '10px' }}
                onClick={() => {
                  setHistoryType("vitals");
                  setShowHistoryModal(true);
                }}
              >
                Vitals History
              </span>
              <span style={{ margin: '0 8px', color: '#888' }}>|</span>
              <span
                className="modalfooterclickeventtext mx-2"
                style={{ cursor: 'pointer', marginLeft: '10px' }}
                onClick={() => {
                  setHistoryType("metabolics");
                  setShowHistoryModal(true);
                }}
              >
                Metabolics History
              </span>
            </div>
        </div>
      )}
      <VitalsMetabolicsModal
        show={showVitalsModal}
        handleClose={() => {setShowVitalsModal(false);props.onRefresh()}}
        rowData={rowData}
        isVitals={rowData.isVitals}
        selectedFamilyMember={props.selectedFamilyMember}
      />
      <ViewHistory
        show={showHistoryModal}
        handleClose={() => {setShowHistoryModal(false);props.onRefresh()}}
        onEdit={handleEdit}
        onEditMetabolics={handleEditMetabolics}
        onDelete={handleDelete}
        userId={props.userId} // pass the userId as needed
        selectedFamilyMember={props.selectedFamilyMember}
        historyType={historyType}
      />
    </div >
  );
};

export default AddVitals;

